"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _index = _interopRequireDefault(require("@site/pattern-library/page-body/other/disclaimer-modal/index.js"));
var _configContext = require("../../context/config-context");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * PrecheckDisclaimer Component.
 *
 * A wrapper component for DisclaimerModal specifically configured for precheck disclaimers.
 *
 * @returns {React.ReactElement} PrecheckDisclaimer Component
 * @public
 */
function PrecheckDisclaimer() {
  const {
    configData
  } = (0, _configContext.useConfig)();
  const {
    disclaimers
  } = configData || {};
  const baseId = (0, _react.useId)();
  const disclaimerItems = (0, _react.useMemo)(() => disclaimers?.items?.map((item, index) => ({
    id: `${baseId}-item-${index}`,
    text: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: _dompurify.default.sanitize(item.text)
      }
    }),
    symbol: item.symbol
  })) || [], [disclaimers?.items, baseId]);
  const modalId = (0, _react.useId)();

  // Don't render if no disclaimer data is available
  if (!disclaimers?.items?.length) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_index.default, {
    id: modalId,
    _name: 'precheck-disclaimer',
    heading: disclaimers.modalHeading,
    items: disclaimerItems,
    text: disclaimers.triggerText,
    verticalMargin: "medium"
  });
}
var _default = exports.default = PrecheckDisclaimer;